export default __webpack_public_path__ + "static/media/dat.69bf0704.svg";